import z from 'zod';

/** Shared shape of the sparkline payload returned by the KPI endpoints. */
export const sparklineSchema = z.object({
  granularity: z.string(),
  points: z.array(
    z.object({
      start: z.string(),
      end: z.string(),
      value: z.number().nullable(),
    })
  ),
});
